import { z } from 'zod';
import { TextItem } from './common';
export var RiskCurve = TextItem;
export var RiskFactors = z.array(RiskCurve).prefault([]);
